import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TableStyled } from './Table.styled';
const Table = forwardRef((props, ref) => {
    return _jsx(TableStyled, { ref: ref, ...props });
});
export { Table };
